// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lazy-load-image-background.blur {
  filter: blur(15px);
}

.lazy-load-image-background.blur.lazy-load-image-loaded {
  filter: blur(0);
  transition: filter .3s;
}

.lazy-load-image-background.blur>img {
  opacity: 0;
}

.lazy-load-image-background.blur.lazy-load-image-loaded>img {
  opacity: 1;
  transition: opacity .3s;
}`, "",{"version":3,"sources":["webpack://./src/js/components/container/CourseCards/blur.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB","sourcesContent":[".lazy-load-image-background.blur {\n  filter: blur(15px);\n}\n\n.lazy-load-image-background.blur.lazy-load-image-loaded {\n  filter: blur(0);\n  transition: filter .3s;\n}\n\n.lazy-load-image-background.blur>img {\n  opacity: 0;\n}\n\n.lazy-load-image-background.blur.lazy-load-image-loaded>img {\n  opacity: 1;\n  transition: opacity .3s;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
